module.exports = __webpack_public_path__ + "static/media/luberly_logo.60760736.png";